import gql from 'graphql-tag';
import { query } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodeQuery = gql`
  query uploads($id: ID!) {
    uploads(id: $id) {
      data {
        ...surfaceNodeUnionDetails
      }
      error
      success
    }
  }
  ${surfaceUnionFragment}
`;

export default query(surfaceNodeQuery);
